import { useState, useEffect } from "react";

const TRACKING_CONSENT_KEY = "tracking_consent";
const TRACKING_CONSENT_DECLINED_KEY = "tracking_consent_declined";

export const useTrackingConsent = () => {
  const [hasConsented, setHasConsented] = useState(false);
  const [hasDeclined, setHasDeclined] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(TRACKING_CONSENT_KEY);
    const declined = localStorage.getItem(TRACKING_CONSENT_DECLINED_KEY);

    if (consent === "true") {
      setHasConsented(true);
    } else if (declined === "true") {
      setHasDeclined(true);
    }

    setIsInitialized(true);
  }, []);

  const acceptConsent = () => {
    localStorage.setItem(TRACKING_CONSENT_KEY, "true");
    localStorage.removeItem(TRACKING_CONSENT_DECLINED_KEY);
    setHasConsented(true);
    setHasDeclined(false);
  };

  const declineConsent = () => {
    localStorage.setItem(TRACKING_CONSENT_DECLINED_KEY, "true");
    localStorage.removeItem(TRACKING_CONSENT_KEY);
    setHasDeclined(true);
    setHasConsented(false);
  };

  const resetConsent = () => {
    localStorage.removeItem(TRACKING_CONSENT_KEY);
    localStorage.removeItem(TRACKING_CONSENT_DECLINED_KEY);
    setHasConsented(false);
    setHasDeclined(false);
  };

  const shouldShowConsent = isInitialized && !hasConsented && !hasDeclined;

  return {
    hasConsented,
    hasDeclined,
    isInitialized,
    acceptConsent,
    declineConsent,
    resetConsent,
    shouldShowConsent,
  };
};
